
import Menu from "../../common/menu";
import Footer from "../../common/footer";
import SpecialEventBooking from "./special-event-booking";
import { BookingProvider } from "../../../contexts/bookingContext";

function MainSpecialEventBooking() {
    return (
        <div className="content-wrapper">
            <Menu />
            <BookingProvider> 
                <SpecialEventBooking />
            </BookingProvider>
            <Footer />

        </div>
    );
}

export default MainSpecialEventBooking;